/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var kendo_angular_common_1 = require("@progress/kendo-angular-common");
var dom_service_1 = require("./dom.service");
var util_1 = require("../util");
/**
 * @hidden
 */
exports.THRESHOLD_DIFF = 1;
/**
 * @hidden
 */
var ScrollableService = /** @class */ (function () {
    function ScrollableService(_dom, _zone) {
        this._dom = _dom;
        this._zone = _zone;
    }
    ScrollableService.prototype.forElement = function (element) {
        this.unsubscribe();
        this.element = element;
        return this;
    };
    ScrollableService.prototype.subscribe = function (callback) {
        var _this = this;
        if (!callback || !kendo_angular_common_1.isDocumentAvailable() || !this.element) {
            return;
        }
        var parents = this._dom.scrollableParents(this.element);
        this._zone.runOutsideAngular(function () {
            var observables = parents.map(function (p) { return rxjs_1.fromEvent(p, "scroll").pipe(operators_1.auditTime(util_1.FRAME_DURATION)); });
            var subscriber = function (e) {
                var target = e.target;
                var isParent = parents.filter(function (p) { return p === target; }).length > 0;
                var isDocument = target === document;
                var isWindow = target === window;
                if (isParent || isDocument || isWindow) {
                    callback(_this.isVisible(_this.element, target));
                }
            };
            _this.subscription = rxjs_1.merge.apply(void 0, observables).subscribe(subscriber);
        });
    };
    ScrollableService.prototype.unsubscribe = function () {
        if (!this.subscription) {
            return;
        }
        this.subscription.unsubscribe();
    };
    ScrollableService.prototype.isVisible = function (elem, container) {
        var elemRect = this._dom.boundingOffset(elem);
        var containerRect = this._dom.boundingOffset(this._dom.nativeElement(container));
        if (exports.THRESHOLD_DIFF < (containerRect.top - elemRect.bottom)) {
            return false;
        }
        if (exports.THRESHOLD_DIFF < (elemRect.top - containerRect.bottom)) {
            return false;
        }
        if (exports.THRESHOLD_DIFF < (elemRect.left - containerRect.right)) {
            return false;
        }
        if (exports.THRESHOLD_DIFF < (containerRect.left - elemRect.right)) {
            return false;
        }
        return true;
    };
    ScrollableService = tslib_1.__decorate([
        core_1.Injectable(),
        tslib_1.__metadata("design:paramtypes", [dom_service_1.DOMService, core_1.NgZone])
    ], ScrollableService);
    return ScrollableService;
}());
exports.ScrollableService = ScrollableService;
